import { memo } from 'react'
import { Theme } from '@mui/material/styles'
import Skeleton from '@mui/material/Skeleton'
import * as CSSTypes from 'csstype'

import useEmotionStyles from 'hooks/useEmotionStyles'
import { Logo, bankLogos } from 'components/LoadingLead/Logos'

const FAKE_BANKS = [
  'targobank',
  'ingDiba',
  'commerzbank',
  'dkb',
  'postbank',
  'deutscheBank'
]

const SKELETONS_NUMBER = 4
const DEFAULT_HEIGHT = 32

const getBankNames = (fakeBankListNames?: string[]): string[] => {
  if (fakeBankListNames) {
    return fakeBankListNames
  }
  return FAKE_BANKS
}

interface FakeOffersProps {
  fakeBankListNames?: string[]
}

const FakeOffers = ({ fakeBankListNames }: FakeOffersProps) => {
  const {
    root,
    fakeOffer,
    fakeOfferTitle,
    skeletonsContainer,
    skeletonBlock,
    skeleton
  } = useEmotionStyles<ReturnType<typeof styles>>(styles)

  const fakeBanks = getBankNames(fakeBankListNames)
  const arrayTemplate = [...Array(SKELETONS_NUMBER)]

  return (
    <div className={root}>
      {fakeBanks.map((fakeBank) => {
        // @ts-ignore - bankLogos type needs refinement for dynamic access
        const logoId = String(bankLogos[fakeBank])

        return (
          // @ts-ignore - bankLogos type needs refinement for dynamic access
          <div className={fakeOffer} key={bankLogos[fakeBank]}>
            <div className={fakeOfferTitle}>
              <Logo logoId={logoId} bankName={fakeBank} />
            </div>

            <div className={skeletonsContainer}>
              {arrayTemplate.map((element, index) => (
                <div
                  className={skeletonBlock}
                  key={`skeletonblock-${element || index}`}
                >
                  <Skeleton
                    className={skeleton}
                    width="90%"
                    height={DEFAULT_HEIGHT}
                    animation="wave"
                  />
                  <Skeleton
                    className={skeleton}
                    width="100%"
                    height={16}
                    animation="wave"
                  />
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default memo(FakeOffers)

const styles = (theme: Theme) => ({
  root: {
    position: 'relative' as CSSTypes.Property.Position,
    width: '100%',
    marginTop: theme.spacing(4)
  },

  fakeOffer: {
    position: 'relative' as CSSTypes.Property.Position,
    marginBottom: theme.spacing(2),
    borderRadius: '8px',
    zIndex: 1,
    border: `1px solid ${theme.palette.grey[300]}`
  },

  fakeOfferTitle: {
    '& img': {
      height: '30px'
    },

    position: 'relative' as CSSTypes.Property.Position,
    background: 'none',
    display: 'flex',
    alignItems: 'center',
    height: '44px',
    padding: '16px'
  },

  skeleton: {
    borderRadius: '20px/40px'
  },

  skeletonsContainer: {
    display: 'grid',
    width: '100%',
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: '0 0 8px 8px',

    [theme.breakpoints.up('xs')]: {
      gridTemplateColumns: 'repeat(2, 50%)'
    },

    [theme.breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(4, 25%)'
    }
  },

  skeletonBlock: {
    padding: theme.spacing(2.5),
    zIndex: -1,

    '&:nth-child(n+3)': {
      display: 'none',

      [theme.breakpoints.up('sm')]: {
        display: 'block'
      }
    }
  }
})
